import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import PainDesire from '../components/PainDesire';
import WhyDifferent from '../components/WhyDifferent';
import HowItWorks from '../components/HowItWorks';
import Proposal from '../components/Proposal';
import LeadMagnet from '../components/LeadMagnet';
import Testimonials from '../components/Testimonials';
import PremiumScarcity from '../components/PremiumScarcity';
import ContactForm from '../components/ContactForm';
import CallToAction from '../components/CallToAction';
import Footer from '../components/Footer';
import FloatingWhatsApp from '../components/FloatingWhatsApp';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-primary-white text-primary-black flex flex-col">
      <Header />
      <Hero />
      <About />
      <PainDesire />
      <WhyDifferent />
      <HowItWorks />
      <Proposal />
      <LeadMagnet />
      <Testimonials />
      <PremiumScarcity />
      <ContactForm />
      <CallToAction />
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default HomePage;
